// import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, BarChart3, Users2, Boxes } from 'lucide-react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import Features from '../../components/Features';
// Removed PayrollSection since it's not used
// import FeatureCards from '../../components/Feature-card';
// import JoinCompaniesSection from '../../components/Company';
import dashboardImage from '../../assets/img/dash-today.png';

function App() {
    // Removed unused state: expanded and setExpanded

    const features = [
        {
            id: 1,
            icon: <BarChart3 className="w-12 h-12 text-[#732570]" />,
            title: "Efficient Payroll System",
            description:
                "Experience seamless payroll processing with automated calculations, tax compliance, and direct deposits, ensuring timely and accurate payments.",
        },
        {
            id: 2,
            icon: <Users2 className="w-12 h-12 text-[#732570]" />,
            title: "Staff Management",
            description:
                "Manage your workforce effectively with tools for attendance tracking, performance reviews, and employee self-service, all integrated into one platform.",
        },
        {
            id: 3,
            icon: <Boxes className="w-12 h-12 text-[#732570]" />,
            title: "Supply Chain Optimization",
            description:
                "End-to-end inventory management, procurement automation, and supplier relationship management to reduce costs and improve efficiency.",
        },
    ];

    return (
        <div className="">
            <Navbar />

            <section className="relative py-12 bg-white sm:py-16 lg:py-20">
                <div className="absolute inset-0">
                    <img
                        className="object-cover w-full h-full"
                        src="https://landingfoliocom.imgix.net/store/collection/clarity-blog/images/hero/5/grid-pattern.png"
                        alt="Background pattern"
                    />
                </div>

                <div className="relative px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl mt-20 md:mt-10">
                    <div className="max-w-4xl mx-auto text-center">
                        <h1 className="text-4xl font-medium md:font-bold text-gray-900 sm:text-4xl lg:text-8xl md:leading-7">
                            Run your Business Like a Pro
                        </h1>
                        <p className="max-w-md mx-auto mt-6 text-base font-normal leading-7 text-gray-500">
                            Streamline operations, boost efficiency, and grow smarter—all in one place.
                        </p>

                        <form
                            action="#"
                            method="POST"
                            className="max-w-md mx-auto mt-8 space-y-4 sm:space-x-4 sm:flex sm:space-y-0 sm:items-end"
                        >
                            <div className="flex-1">
                                <label htmlFor="email" className="sr-only">
                                    Email address
                                </label>
                                <div>
                                    <input
                                        type="email"
                                        id="email"
                                        className="block w-full px-4 py-3 sm:py-3.5 text-base font-medium text-gray-900 placeholder-gray-500 border border-gray-300 rounded-lg sm:text-sm focus:ring-gray-900 focus:border-gray-900"
                                        placeholder="Email address"
                                    />
                                </div>
                            </div>

                            <div className="relative group">
                                <div className="absolute transition-all duration-1000 opacity-70 inset-0 bg-primary rounded-xl blur-lg filter group-hover:opacity-100 group-hover:duration-200"></div>
                                <button
                                    type="button"
                                    className="inline-flex relative items-center justify-center w-full sm:w-auto px-8 py-3 sm:text-sm text-base sm:py-3.5 font-semibold text-white transition-all duration-200 bg-[#732570] border border-transparent rounded-lg hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                                >
                                    Join Now
                                </button>
                            </div>
                        </form>

                        <ul className="flex items-center justify-center mt-6 space-x-6 sm:space-x-8">
                            <li className="flex items-center">
                                <Check className="w-5 h-5 mr-2 text-gray-400" />
                                <span className="text-xs font-medium text-gray-900 sm:text-sm">Efficient management</span>
                            </li>

                            <li className="flex items-center">
                                <Check className="w-5 h-5 mr-2 text-gray-400" />
                                <span className="text-xs font-medium text-gray-900 sm:text-sm">Join other 1600+ Businesses</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-col md:flex-row p-4 max-w-5xl mx-auto w-full gap-6 pb-8 mt-12 overflow-x-auto sm:mt-16 lg:mt-20 snap-x">
                    {features.map((feature) => (
                        <div
                            key={feature.id}
                            className="relative p-8 bg-purple-50 backdrop-blur-sm rounded-2xl shadow-sm transition-all duration-200 hover:shadow-lg hover:-translate-y-1"
                        >
                            <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-50 rounded-xl mb-6">
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                            <p className="text-base text-gray-600 leading-relaxed">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="pb-8 bg-white sm:pb-12 lg:pb-12">
                <div className="pt-8 overflow-hidden sm:pt-12 lg:relative lg:py-40">
                    <div className="max-w-md px-4 mx-auto sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl lg:grid lg:grid-cols-2 lg:gap-24">
                        <div className="lg:mt-16">
                            <div className="mx-auto text-center sm:max-w-lg lg:max-w-xl lg:text-left lg:mx-0">
                                <h1 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl xl:text-7xl sm:tracking-tight">
                                    Powerful Insights at Your Fingertips
                                </h1>
                                <p className="mt-6 text-lg leading-7 text-gray-700 lg:leading-8 lg:text-xl">
                                    Easily track your business performance with our intuitive dashboard. Get real-time insights, monitor key metrics, and make smarter decisions with interactive visuals and customizable widgets.
                                </p>
                            </div>

                            <div className="flex flex-col items-stretch justify-center gap-4 mt-8 sm:flex-row sm:items-center sm:mt-10 lg:justify-start sm:flex-wrap">
                                <Link
                                    to="/start-using"
                                    className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white transition-all duration-200 bg-[#732570] border border-transparent rounded-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-700"
                                >
                                    Start using Payrender
                                </Link>

                                <Link
                                    to="/intro"
                                    className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-gray-900 transition-all duration-200 border border-gray-300 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
                                >
                                    <svg
                                        className="w-6 h-6 mr-3 -ml-1 text-blue-600"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Watch 1 min intro
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
                        <div className="py-12 mt-6 sm:relative sm:mt-12 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                            <div className="relative pl-10 -mr-40 sm:max-w-3xl lg:max-w-none lg:h-full lg:pl-24">
                                <img
                                    className="w-full shadow-2xl rounded-xl lg:rounded-2xl ring-[24px] lg:ring-[48px] ring-[#732570] lg:h-full lg:w-auto lg:max-w-none"
                                    src={dashboardImage}
                                    alt="Dashboard Mockup"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="">
                    <Features />
                </div>

                <div className="md:my-20 md:mb-10">
                    <section className="relative sticky top-4 overflow-hidden bg-[#732570] max-w-7xl mx-auto md:rounded-2xl md:my-20 mb-0 shadow-[0_16px_40px_rgba(115,37,112,0.3)]">
                        <div className="absolute opacity-40"></div>
                        <div className="relative mx-auto max-w-7xl">
                            <div className="grid items-center grid-cols-1 gap-y-16 gap-x-8 lg:grid-cols-2">
                                <div className="relative h-full order-2 md:order-1">
                                    <div className="aspect-[4/3] relative z-10">
                                        <div className="absolute -inset-4 bg-[#732570] rounded-3xl"></div>
                                        <div className="relative animate-float">
                                            <img className="w-full" src="https://cdn.rareblocks.xyz/collection/celebration/images/hero/4/phone-mockup.png" alt="Phone mockup" />
                                        </div>
                                    </div>
                                    <div className="absolute -z-10 left-0 top-0 h-96 w-96 opacity-20 bg-gradient-conic from-purple-900 via-[#732570] to-purple-900 blur-2xl"></div>
                                    <div className="absolute -z-10 right-0 bottom-0 h-96 w-96 opacity-20 bg-gradient-conic from-purple-900 via-[#732570] to-purple-900 blur-2xl"></div>
                                </div>

                                <div className="md:order-2">
                                    <div className="relative p-8 pt-16 sm:px-6 lg:px-8">
                                        <h2 className="text-3xl sm:text-4xl lg:text-8xl font-bold text-white animate-gradient">
                                            Payroll Made Magical
                                        </h2>
                                        <p className="mt-6 text-xl text-gray-50 leading-relaxed">
                                            Experience the future of payroll management. Our intelligent system handles complex calculations, tax compliance, and direct deposits with unprecedented ease and accuracy.
                                        </p>
                                        <div className="mt-12">
                                            <button className="inline-flex items-center px-8 py-4 text-lg font-semibold bg-white text-[#732570] rounded-xl shadow-lg transition-all duration-200 hover:bg-opacity-90 hover:shadow-xl hover:-translate-y-1">
                                                Transform Your Payroll
                                                <svg className="w-5 h-5 ml-2 animate-bounce-x" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default App;